module.exports = __webpack_public_path__ + "static/media/logos.e2050896.png";